import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.seek.com',
    clientDomain: 'my.employer.seek.com',
    clientId: '6IjJ81HLrj3r53GxPa8ufS51IX9Os0lF',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://www.jobstreet.com/about-us/contact-us-malaysia/',
    },
    siteName: siteNames.employer.seek.my,
    zone: getZoneFromSite(siteNames.employer.seek.my),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=my_employer_seek_com.js.map